<div class="container">
    <div class="rank">
        {{rank}}
    </div>
    <div class="logo">
        <img class="teamLogo" src="{{logo}}">
    </div>
    <div class="name">{{name}}</div>
    <div class="value">{{value}}</div>
  </div>